import { hashHistory } from "react-router";
import { partArray } from "config/staticConfig";
import { groupBy } from "lodash";
import SystemActions from "actions/system-actions";
import Tools from "./tools";

export const isNumber = n => n === +n;
// 根据字段去重  返回数组 不重复的字段值数组
export const arrFieldReSet = (arr, field) => {
  if (!Array.isArray(arr)) return [];
  const result = [];
  arr.forEach(item => {
    if (result.indexOf(item[field]) === -1) {
      result.push(item[field]);
    }
  });
  return result;
};

// 根据字段去重  返回数组对象
export const arrFieldReSetObj = (arr, field) => {
  if (!Array.isArray(arr)) return [];
  const result = [];
  const compare = [];
  arr.forEach(item => {
    if (compare.indexOf(item[field]) === -1) {
      compare.push(item[field]);
      result.push(item);
    }
  });
  return result;
};
// 降序
export const sortDesc = arr =>
  arr.sort((a, b) => {
    if (a.unitSize > b.unitSize) {
      return -1;
    }
    if (a.unitSize < b.unitSize) {
      return 1;
    }
    return 0;
  });

// 进入全屏
export const enterFullScreen = callback => {
  const docElm = document.documentElement;
  try {
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
  } catch (err) {
    console.log(err);
  } finally {
    callback && callback();
  }
};
// 退出全屏
export const exitFullScreen = callback => {
  try {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  } catch (err) {
    console.log(err);
  } finally {
    callback && callback();
  }
};

// 全屏进入基地详情
export const enterFullPage = (e, url) => {
  e && e.preventDefault();
  enterFullScreen(() => {
    hashHistory.push(url);
  });
};

// null,undefined,''返回 '--'
export const filterNullData = (value, number) => {
  if (number) {
    return value === null || value === "" || value === undefined || isNaN(value)
      ? "--"
      : value;
  }
  return value === null || value === "" || value === undefined ? "--" : value;
};

// 取消promise
export const makeCancelable = promise => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val =>
        hasCanceled_
          ? reject({
              isCanceled: true
            })
          : resolve(val),
      error =>
        hasCanceled_
          ? reject({
              isCanceled: true
            })
          : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
};

export const handleImgObj = (value, isArray = false) => {
  if (!value) return "";
  let valueArr = [];
  if (value && JSON.stringify(value) != "[]") {
    valueArr = value.split(",");
    if (!valueArr[valueArr.length - 1]) {
      valueArr.splice(-1);
    }
  }
  if (isArray) {
    return valueArr;
  }
  return valueArr[0];
};
// 转化成 img对象 上传组件value 格式
export const transImgsData = defaultValue => {
  if (!defaultValue) return [];
  let imgArr = defaultValue;
  if (Object.prototype.toString.call(defaultValue[0]) !== "[object Object]") {
    imgArr = handleImgObj(defaultValue, true);
    return imgArr.map((item, index) => ({
      uid: index,
      name: `${index}.png`,
      status: "done",
      url: item
    }));
  }
  return defaultValue;
};
// getImgs 获取上传图片的value 逗号拼接成字符串 传给后台
export const getImgsData = fileList => {
  if (!fileList) return "";
  if (!Array.isArray(fileList)) return fileList;
  const fileLists = fileList.map(item =>
    item.url
      ? item.url.split("?")[0]
      : item.response
      ? item.response.data.url
      : ""
  );
  return fileLists.join(",");
};
// 获取当前 hostname, 传递参数 true 为获取带 ?ddd (window.location.search) 的地址
export const getHost = flag => {
  if (flag)
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;
  return `${window.location.protocol}//${window.location.host}${window.location.pathname}`.replace(
    "index.html",
    ""
  );
};

/**
 * 转换风向值
 *
 * @param {number} value  原始值
 * @param {number} productId 产品 4990多功能气象仪 6725智能数据采集器
 */
export const transWindDirection = (value, productId, speed) => {
  if (productId === 8383) {
    if (speed <= 0.2) {
      return "静风";
    }
    if ((value >= 348.76 && value <= 360) || (value >= 0 && value <= 11.25)) {
      return "北风";
    }
    if (value <= 33.75 && value >= 11.26) {
      return "北东北风";
    }
    if (value <= 56.25 && value >= 33.76) {
      return "东北风";
    }
    if (value <= 78.75 && value >= 56.26) {
      return "东东北风";
    }
    if (value <= 101.25 && value >= 78.76) {
      return "东风";
    }
    if (value <= 123.75 && value >= 101.26) {
      return "东东南风";
    }
    if (value <= 146.25 && value >= 123.76) {
      return "东南风";
    }
    if (value <= 168.75 && value >= 146.26) {
      return "南东南风";
    }
    if (value <= 191.25 && value >= 168.76) {
      return "南风";
    }
    if (value <= 213.75 && value >= 191.26) {
      return "南西南风";
    }
    if (value <= 236.25 && value >= 213.76) {
      return "西南风";
    }
    if (value <= 258.75 && value >= 236.26) {
      return "西西南风";
    }
    if (value <= 281.25 && value >= 258.76) {
      return "西风";
    }
    if (value <= 303.75 && value >= 281.26) {
      return "西西北风";
    }
    if (value <= 326.25 && value >= 303.76) {
      return "西北风";
    }
    if (value <= 348.75 && value >= 326.26) {
      return "北西北风";
    }
  }
  if (productId === 4990) {
    switch (value) {
      case 1:
        return "北风";
      case 2:
      case 3:
      case 4:
        return "东北风";
      case 5:
        return "东风";
      case 6:
      case 7:
      case 8:
        return "东南风";
      case 9:
        return "南风";
      case 10:
      case 11:
      case 12:
        return "西南风";
      case 13:
        return "西风";
      case 14:
      case 15:
      case 16:
        return "西北风";
      default:
        return value ? `${value}°` : "--";
    }
  }
  if (productId === 6725) {
    switch (value) {
      case 0:
        return "北风";
      case 45:
        return "东北风";
      case 90:
        return "东风";
      case 135:
        return "东南风";
      case 180:
        return "南风";
      case 225:
        return "西南风";
      case 270:
        return "西风";
      case 315:
        return "西北风";
      default:
        return value ? `${value}°` : "--";
    }
  }
};

// 处理权限树or数组
export function getAuthArray(
  data,
  pid = 0,
  array = [],
  obj = {},
  objCode = {},
  codePrentId = {},
  checked = []
) {
  if (!data) {
    return {
      array: [],
      obj: {},
      objCode: {},
      codePrentId: {},
      checked: []
    };
  }
  for (let i = 0; i < data.length; i += 1) {
    array.push(data[i].rightCode);
    obj[data[i].rightId] = {
      level: data[i].level,
      rightCode: data[i].rightCode,
      rightId: data[i].rightId,
      pid,
      isCheck: data[i].isCheck || 0,
      hasChildren: !!data[i].subRights
    };
    codePrentId[data[i].rightCode] = data[i].upper;
    objCode[data[i].rightCode] = data[i].rightId;
    // if (data[i].isCheck === 1) {
    checked.push(data[i].rightCode);
    // }
    if (data[i].subRights) {
      const result = getAuthArray(data[i].subRights, data[i].rightId);
      array = array.concat(result.array);
      checked = checked.concat(result.checked);
      obj = Object.assign({}, obj, result.obj);
      objCode = Object.assign({}, objCode, result.objCode);
      codePrentId = Object.assign({}, codePrentId, result.codePrentId);
    }
  }
  return { array, obj, objCode, checked, codePrentId };
}
// 独立登录页配置需要开发网址
export const nowEnvAdress = local => {
  const ENV = {
    "200.200.200.50": "https://200.200.200.50/platformAdmin/farm/",
    "200.200.200.16": "https://200.200.200.16/platformAdmin/farm/",
    "dp.clife.net": "https://dp.clife.net/platformAdmin/farm/",
    "cms.clife.cn": "https://cms.clife.cn/platformAdmin/farm/",
    "pre.cms.clife.cn": "https://pre.cms.clife.cn/pre-platformAdmin/farm/"
  };
  if (window.location.hostname === "localhost") {
    switch (
      local // 开发环境需要手动处理
    ) {
      case "test":
        return "https://200.200.200.50/platformAdmin/farm/";
      case "develop":
        return "https://pre.cms.clife.cn/pre-platformAdmin/farm/";
      case "product":
        return "https://cms.clife.cn/platformAdmin/farm/";
      default:
        return "https://pre.cms.clife.cn/pre-platformAdmin/farm/";
    }
  }
  return ENV[window.location.host];
};
// 生成hover颜色
export const getHoverColor = rgb => {
  if (!rgb) return "#ff0000";
  const r = Math.floor(parseInt(rgb.slice(1, 3), 16) * 0.8).toString(16);
  const g = Math.floor(parseInt(rgb.slice(3, 5), 16) * 0.8).toString(16);
  const b = Math.floor(parseInt(rgb.slice(5, 7), 16) * 0.8).toString(16);
  return `#${r.length === 1 ? `0${r}` : r}${g.length === 1 ? `0${g}` : g}${
    b.length === 1 ? `0${b}` : b
  }`;
};
// env
export const isSuperAdmin = userId => {
  const ENV = {
    "10.8.16.11": 100000170,
    "200.200.200.50": 100000170,
    "200.200.200.16": 100000170,
    "dp.clife.net": 100000170,
    "cms.clife.cn": 100000170,
    "pre.cms.clife.cn": 100000077,
    "localhost:8080": 100000077 // todo 本地代理需要处理下
  };
  if (ENV[window.location.host] == userId) {
    return true;
  }
  return false;
};
export const getPartitionValue = provinceName => {
  let PartitionValue = null;
  for (let i = 0; i < partArray.length; i += 1) {
    if (partArray[i].indexOf(provinceName) !== -1) {
      PartitionValue = (i + 1) * 100;
      break;
    }
  }
  return PartitionValue;
};

export const handleVideoException = (exception = 0) => {
  if (isNaN(parseInt(exception))) return;
  let err = null;
  switch (parseInt(exception)) {
    case 0: // 正常
      // err = "正常"; // mock
      break;
    case 1:
      err = "设备不在线";
      break;
    case 2:
      err = "设备开启视频加密";
      break;
    case 3:
      err = "设备删除";
      break;
    case 4:
      err = "失效";
      break;
    case 5:
      err = "设备未绑定";
      break;
    case 6:
      err = "账户下流量已超出";
      break;
    case 7:
      err = "设备接入限制";
      break;
    default:
      err = "存在异常";
      break;
  }
  return err;
};

// 是否为云图片 是：返回图片host
export const isCloud = src => {
  const NO_NEED_SIGN_HOST = [
    "cos.clife.net",
    "pic.cos.clife.net",
    "skintest.hetyj.com",
    "tencentest.hetyj.com"
  ];
  const regHost = /^http(s)?:\/\/(.*?)\//;
  const host = regHost.exec(src) && regHost.exec(src)[2];
  if (NO_NEED_SIGN_HOST.indexOf(host) !== -1) return host;
  return false;
};
export const handleLevel = level => {
  let text;
  switch (level) {
    case 2:
      text = "low";
      break;
    case 3:
      text = "high";
      break;
    default:
      break;
  }
  return text;
};

// ------------------徐闻大屏-----------------------------------
/**
 *  文案超出滚动 如果内容不超出不滚动
 * @param  {HTMLElement} target [dom]
 * @param  {[number]} move [移动距离]
 * @param  {[number]} time [间隔时间]
 * @param  {[function]} cb [回调函数] 滚动至底部时执行cb
 * @return 定时器id(组件卸载时，受到清除该定时器)
 * const infoDom = ReactDOM.findDOMNode(this.refs.info);
 * eg.scrollText(infoDom,1,100,cb)
 */
export const ScrollText = (target, move = 1, time = 100, cb) => {
  let isSet = false;
  if (!(target instanceof HTMLElement)) return; // 非dom元素
  const { scrollHeight, offsetHeight } = target;
  const overHeight = scrollHeight - offsetHeight; // 超出的高度,未超出为负数
  if(target.scrollTop > overHeight) return;
  // console.log("before",target.scrollTop,scrollHeight, offsetHeight)
  let timeOut = null;
  let setTim = setInterval(() => {
    const { scrollHeight, offsetHeight } = target;
    const overHeight = scrollHeight - offsetHeight; // 超出的高度
    target.scrollTop += move;
    // console.log("after",target,target.scrollTop,scrollHeight, offsetHeight)


    if (
      (target.scrollTop == overHeight || target.scrollTop > overHeight) &&
      target.scrollTop!=0
    ) {
      isSet = false;
      timeOut = setTimeout(() => {
        target.scrollTop = 0; // 滚动至底部 重置
        if (cb && typeof cb === "function" && !isSet) {
          cb();
          isSet = true;
        }
      }, 2000);
    }else if(target.scrollTop > overHeight){
      // console.log(111111111111)
    }
   /*  else if(target.scrollTop == overHeight&&target.scrollTop === 0){
      console.log(111111111111)
    } */
  }, time);

  return {setTim,timeOut}
};
/* 根据等级划分 */
export const handleStatus = warningType => {
  switch (warningType) {
    case 1:
      return "偏低";
    case 2:
      return "偏低";
    case 3:
      return "正常";
    case 4:
      return "偏高";
    case 5:
      return "偏高";
    default:
      return "--";
  }
};
// 根据因子分类设备  因子类型：1,环境 2,土壤 3,果实成分 4,植物营养
export const classifyBlockDevice = list => {
  if (!list || !list.length) return {};
  const deviceData = groupBy(list, item => {
    switch (item.productId) {
      case 6288: // 微型气象仪
        return 2;
      case 4990: // 多功能气象站（气象墒情仪）
        return 1;
      case 6716: // 植物营养检测仪
        return 4;
      default:
        return "无分类";
    }
  });
  return deviceData;
};

export const checkVal = (value, noshow) =>
  Object.prototype.toString.call(value) == "[object Number]"
    ? value
    : noshow || "--";
// 进入全屏
export const xwEnterFullScreen = (id, callback) => {
  let docElm;
  if (!id) {
    docElm = document.getElementById("ysz-xw-main");
    docElm.style.zoom = 1;
    docElm.style.left = 0;
    docElm.style.top = 0;
  } else if (typeof id === "string") {
    docElm = document.getElementById(id);
  }
  try {
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
  } catch (err) {
    console.log(err);
  } finally {
    typeof callback === "function" && callback();
  }
};
// 退出全屏
export const xwExitFullScreen = callback => {
  let docElm;
  if (!callback) {
  } else if (typeof callback === "string") {
    docElm = document.getElementById(callback);
  }
  try {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  } catch (err) {
    console.log(err);
  } finally {
    typeof callback === "function" && callback();
  }
};
export const isFullscreen = () => {
  if (Tools.isIE()) { // IE
    return window.screen.height==document.body.clientHeight 
    && window.screen.width == document.body.clientWidth;
  } else { // webkit  fireFox
    return window.fullScreen|| document.fullScreen || document.webkitIsFullScreen;
  }
};
// -----------------------徐闻end-------------------------

// 获取url问号之后的param参数的value
export const getUrlParam = paramName => {
  if (paramName && typeof paramName === "string") {
    let sValue = "";
    const re = new RegExp(`${paramName}=([^&=]+)`);
    let st = null;
    const urlSt = window.location.hash.split("?")[1] || "";
    st = urlSt.match(re);
    if (st && st.length == 2) {
      st[1] = st[1].replace(/^\s*|\s*$/g, "");
      sValue = st[1];
      if (sValue == "") {
        return null;
      }
      return sValue;
    }
    return st;
  }
};
/**
 * 下载文件 例：导出excel
 * @param {Object} fileData 数据流
 * @param {String} fileType 文件格式
 * @param {String} fileName 文件名称
 *
 */
export const downloadFile = (
  fileData = "",
  fileType = "application/vnd.ms-excel",
  fileName = "文件.xls"
) => {
  const blob = new Blob([fileData], { type: fileType });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // IE 兼容处理
    navigator.msSaveBlob(blob, fileName);
  } else {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }
};

/** 解析blob类型
 * @param {Object} blobData blob类文件对象
 * return data  解析后的数据
 */
export const parseBlob = blobData => {
  let data;
  const reader = new FileReader();
  if ("msSaveOrOpenBlob" in navigator) {
    // IE10+
    reader.readAsText(blobData, "utf-8");
    reader.onload = e => {
      data = JSON.parse(reader.result);
    };
  } else {
    // 其他主流浏览器
    reader.readAsArrayBuffer(blobData);
    reader.onload = e => {
      if (e.target.readyState === 2) {
        if (window.TextDecoder) {
          const enc = new TextDecoder("utf-8");
          data = JSON.parse(enc.decode(new Uint8Array(e.target.result))); // 转化成json对象
        } else {
          data = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(e.target.result))
          );
        }
      }
    };
  }
  return data;
};
/* 动态设置favicon */
export const setFavicon = url => {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  const host = isCloud(url);
  // console.log("host", host);
  if (host) {
    SystemActions.getSign(host, sign => {
      // console.log(sign);
      url += sign;
      link.href = url;
      document.getElementsByTagName("head")[0].appendChild(link);
    });
  } else {
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
};

//return env  (0 测试环境 1 预发布环境 2 线上环境)
export const handleEnv=()=>{
  const host = location.host;
  const config = {
    "200.200.200.50":0,
    "dp.clife.net":0,
    "pre.cms.clife.cn":1,
    "cms.clife.cn":2,
  }
  return config[host]||1
}